<div class="container">
  @if (isInitialDataLoading) {
  <div class="initial-loader">
    <mat-spinner diameter="56" color="primary"></mat-spinner>
  </div>
  }

  @if (!isInitialDataLoading) {
  <div class="content-card">
    <mat-form-field class="selected-workers-chip-list" appearance="fill">
      <mat-label>{{ 'SelectedWorkers' | translate }}</mat-label>
      <mat-chip-listbox #chipList aria-label="Worker selection">
        @for (worker of selectedWorkers; track worker) {
        <mat-chip-option>
          {{ worker.Name }}
        </mat-chip-option>
        }
        <input matInput [matChipInputFor]="chipList" disabled />
      </mat-chip-listbox>
    </mat-form-field>
  </div>
  <form [formGroup]="agreementFormGroup" autocomplete="off">
    <div class="content-card">
      <h2 class="content-card__header">{{ 'AW-BasicData' | translate }}</h2>
      <alert message="MultipleAgreementGenerationWarning" alertType="error"></alert>
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Company' | translate }}</mat-label>
            <mat-select formControlName="company">
              <mat-select-trigger>{{ selectedCompany?.Name }}</mat-select-trigger>
              @for (company of listOfCompanies$ | async; track company) {
              <mat-option #matOption [value]="company.Id">{{ company.Name | translate }}</mat-option>
              }
            </mat-select>
            @if (company.invalid && company.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Employer' | translate }}</mat-label>
            <mat-select formControlName="employer" #employerSelect>
              @for (employer of listOfEmployers$ | async; track employer) {
              <mat-option #matOption [value]="employer.Id">{{
                employer.Name | translate
                }}</mat-option>
              }
            </mat-select>
            @if (employer.invalid && employer.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
            <input #employerObjectInput matInput formControlName="employerObject"
              placeholder="{{ 'EmployerObject' | translate }}" [matAutocomplete]="autocompleteEmployerObject" />
            <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
              @for (employerObject of listOfEmployerObjects$ | async; track employerObject) {
              <mat-option [value]="employerObject">
                {{ employerObject.Name }}
              </mat-option>
              }
            </mat-autocomplete>
            @if (employerObject.invalid && employerObject.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>

        @if (orderItemActive && hasAssignOrderItemPermission) {
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'OrderItem' | translate }}</mat-label>
            <mat-select formControlName="orderItem">
              @for (item of listOfAvailableOrderItems$ | async; track item) {
              <mat-option #matOption [value]="item">{{ item.Name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }

        <div class="col-12 col-lg-12">
          @if (isMpkActive) {
          <mat-form-field appearance="outline">
            <mat-label>{{ 'MPK' | translate }}</mat-label>
            <input matInput placeholder="{{ 'MPK' | translate }}" formControlName="mpk" />
          </mat-form-field>
          }

          @if (selectedEmployerObject?.RequireSupervisorOnMultiAgreementsForm) {
          <mat-form-field *hasPermissionToModule="moduleNames.Supervisors" appearance="outline">
            <mat-label>{{ 'Supervisor' | translate }}</mat-label>
            <input matInput formControlName="supervisor" placeholder="{{ 'Supervisor' | translate }}"
              [matAutocomplete]="autocompleteSupervisor" />
            <mat-autocomplete #autocompleteSupervisor="matAutocomplete" [displayWith]="displayValue">
              @for (supervisor of listOfSupervisors$ | async; track supervisor) {
              <mat-option [value]="supervisor">
                {{ supervisor.Name }}
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          }
        </div>

        @if (selectedEmployerObject?.HasLocalization) {
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Location' | translate }}</mat-label>
            <input matInput formControlName="location" placeholder="{{ 'Location' | translate }}"
              [matAutocomplete]="autocompleteLocation" required />
            <mat-autocomplete #autocompleteLocation="matAutocomplete" [displayWith]="displayValue">
              @for (location of listOfLocations$ | async; track location) {
              <mat-option [value]="location">
                {{ location.Name }}
              </mat-option>
              }
            </mat-autocomplete>
            @if (location.invalid && location.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
      </div>
    </div>

    <div class="content-card">
      <h2 class="content-card__header">{{ 'ContractType' | translate }}</h2>

      <div class="row">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AgreementType' | translate }}</mat-label>
            <mat-select formControlName="agreementType">
              @for (agreementType of listOfAgreementTypes$ | async; track agreementType) {
              <mat-option [value]="agreementType.Id">
                {{ agreementType.Name }}
              </mat-option>
              }
            </mat-select>
            @if (agreementType.invalid && agreementType.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'PaymentDeadline' | translate }}</mat-label>
            <mat-select formControlName="paymentDeadline">
              @for (paymentDeadline of listOfPaymentDeadlines$ | async; track paymentDeadline) {
              <mat-option [value]="paymentDeadline.Id">
                {{ paymentDeadline.Name }}
              </mat-option>
              }
            </mat-select>
            @if (paymentDeadline.invalid && paymentDeadline.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-12">
          <app-responsibility-multi-select [control]="responsibilities"
            [filteredResponsibilities$]="filteredResponsibilities$" (filterChanged)="filterSubject.next($event)">
          </app-responsibility-multi-select>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AgreementConclusionDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="pickConclusionDate" formControlName="conclusionDate"
              [matDatepickerFilter]="conclusionDateFilter" required />
            <mat-datepicker-toggle matSuffix [for]="pickConclusionDate"></mat-datepicker-toggle>
            <mat-datepicker #pickConclusionDate></mat-datepicker>
            @if (conclusionDate.invalid && conclusionDate.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'EmploymentDateFrom' | translate }}</mat-label>
            <input matInput [matDatepicker]="pickEmploymentDateFrom" formControlName="employmentDateFrom"
              [matDatepickerFilter]="employmentDateFromFilter" (dateChange)="checkDays('change', $event)" required />
            <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickEmploymentDateFrom></mat-datepicker>
            @if (employmentDateFrom.invalid && employmentDateFrom.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-12">
          @if (indefiniteContractPossible) {
          <mat-checkbox formControlName="isForIndefinitePeriod">
            {{ 'AgreementForAnIndefinitePeriod' | translate }}
          </mat-checkbox>
          }
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'EmploymentDateTo' | translate }}</mat-label>
            <input matInput [matDatepicker]="pickEmploymentDateTo" formControlName="employmentDateTo"
              [matDatepickerFilter]="employmentDateToFilter" (dateChange)="checkDays('change', $event)"
              [required]="!isForIndefinitePeriod.value" />
            <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateTo"></mat-datepicker-toggle>
            <mat-datepicker #pickEmploymentDateTo></mat-datepicker>
            @if (employmentDateTo.invalid && employmentDateTo.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-12" [ngClass]="selectedEmployerObject?.HasWorkPattern ? 'col-lg-3' : 'col-lg-6'">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AF-NoticePeriod' | translate }}</mat-label>
            <mat-select formControlName="noticePeriod" required>
              @for (period of listOfNoticePeriods$ | async; track period) {
              <mat-option [value]="period.Id">
                {{ period.Name }}
              </mat-option>
              }
            </mat-select>
            @if (noticePeriod.invalid && noticePeriod.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        @if (selectedEmployerObject?.HasWorkPattern) {
        <div class="col-12 col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AF-WorkPattern' | translate }}</mat-label>
            <mat-select formControlName="workPattern" required>
              @for (pattern of listOfWorkPatterns$ | async; track pattern) {
              <mat-option [value]="pattern.Id">
                {{ pattern.Name }}
              </mat-option>
              }
            </mat-select>
            @if (workPattern.invalid && workPattern.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
      </div>

      <div class="wages-wrapper">
        @for (wage of dataSource.data; track wage; let i = $index) {
        <div class="row" formArrayName="wages">
          <div class="col-3" [formGroupName]="i">
            <mat-form-field fxFill appearance="outline">
              <mat-label>{{ 'Wage' | translate }}</mat-label>
              <input matInput type="number" class="text-center" formControlName="value" min="0" required />
              @if (wages.controls[i].get('value').invalid && wages.controls[i].get('value').touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-2" [formGroupName]="i">
            <mat-form-field fxFill appearance="outline">
              <mat-label>{{ 'Currency' | translate }}</mat-label>
              <mat-select formControlName="currencyId">
                @for (currency of listOfCurrencies$ | async; track currency) {
                <mat-option [value]="currency.Id">
                  {{ currency.Name }}
                </mat-option>
                }
              </mat-select>
              @if (wages.controls[i].get('currencyId').invalid && wages.controls[i].get('currencyId').touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-3" [formGroupName]="i">
            <mat-form-field fxFill appearance="outline">
              <mat-label>{{ 'WageType' | translate }}</mat-label>
              <mat-select formControlName="wageTypeId">
                @for (wageType of listOfWageTypes$ | async | filterWageType : wages.value : i; track wageType) {
                <mat-option [value]="wageType.Id">
                  {{ wageType.Name }}
                </mat-option>
                }
              </mat-select>
              @if (wages.controls[i].get('wageTypeId').invalid && wages.controls[i].get('wageTypeId').touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-3" [formGroupName]="i">
            <mat-form-field fxFill appearance="outline">
              <mat-label>{{ 'Description' | translate }}</mat-label>
              <mat-select formControlName="wageDescriptionId">
                <mat-option [value]="null"></mat-option>
                @for (wageDescription of filterWageDescriptions(listOfWageDescriptions$ | async, i); track
                wageDescription) {
                <mat-option [value]="wageDescription.Id">
                  {{ wageDescription.Name }}
                </mat-option>
                }
              </mat-select>
              @if (wages.controls[i].get('wageDescriptionId').invalid &&
              wages.controls[i].get('wageDescriptionId').touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-1">
            <button mat-icon-button color="primary" class="trash-button" (click)="deleteWage(i)"
              [disabled]="wageCounter <= miminumWages">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
        }
      </div>

      <button mat-raised-button color="primary" type="button" (click)="addNewWage()">
        <mat-icon>add_box</mat-icon>
        <span>{{ 'AF-AddWage' | translate }}</span>
      </button>
    </div>

    @if (selectedEmployerObject?.HasPreliminaryMedicalExaminationRequirements) {
    <div class="content-card">
      <h2 class="content-card__header">{{ 'OccupationalMedicineResearch' | translate }}</h2>
      <div class="row row--checkbox">
        <div class="col-12">
          <mat-checkbox formControlName="preliminaryMedicalExamination">
            {{ 'AF-PreliminaryMedicalExaminationRequirements' | translate }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    }

    @if (this.isLegalizationFieldVisible() && workerAgreementLegalizationData) {
    <div
      [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']"
      class="content-card">
      <h2 class="content-card__header">{{ 'Legalization.LegalizationStatus' | translate }}</h2>
      <div class="workers-legalization-grid">
        @for (item of foreignWorkersWithData; track item; let i = $index) {
        <div>
          <app-legalization-status-info [element]="item.legalizationData" [size]="'large'" [showStatusText]="true"
            [showTooltip]="false" [showLabel]="true"
            [customLabel]="(i + 1) + '. ' + item.name"></app-legalization-status-info>
        </div>
        }
      </div>
      <div>
        <button mat-raised-button class="legalization-status-btn" type="button"
          [matTooltip]="'Legalization.SubmitForMultipeLegalizationInfo' | translate"
          [matTooltipClass]="'line-broken-tooltip'" (click)="onSubmitForLegalization()">
          {{ 'Legalization.SubmitForLegalization' | translate }}
        </button>
      </div>
    </div>
    }

    <div class="content-card">
      <h2 class="content-card__header">{{ 'AF-TheSetOfDocumentsVersion' | translate }}</h2>

      <div class="row">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AF-TheSetOfDocumentsVersion' | translate }}</mat-label>
            <mat-select formControlName="agreementTemplate" required>
              @for (template of listOfAgreementTemplates$ | async; track template) {
              <mat-option [value]="template.Id">
                {{ template.Name }}
              </mat-option>
              }
            </mat-select>
            @if (agreementTemplate.invalid && agreementTemplate.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6 pt-10">
          <button mat-raised-button color="primary" [disabled]="agreementFormGroup.invalid" (click)="submit()">
            {{ 'AF-GenerateDocument' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  }
</div>